import i18n from '@/lang'
import { Message } from 'element-ui'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { checkCreditInfo } from '@/api/partner/creditInfo'
import { cache, cacheName } from '@/utils/cacheManager'

export class CreditControlUtil {
  static checkCreditByCompany(accountId, callback) {
    //     var map = {}
    //     map[accountId.toString()] = accountId
    //     CreditInfo.checkCreditInfo(map, null,
    //       new mx.rpc.Responder(
    //         function (evt: ResultEvent) {
    //           if (evt.result.length > 0) {
    //             for each(var creditInfo: CreditInfo in evt.result)
    // 						{
    //         callback(creditInfo)
    //       }
    // 					}
    //   else
    //   callback(null)
    // },
    // failureHandler))
  }
  static getCreditEDISetting() {
    // var setting: String = Config.configMap['creditBlockEDI']
    // var a: Array = setting.split(',')
    // var r = {}
    // for each(var o: String in a)
    // {
    //   var lock: Boolean
    //   if (o.split('-')[1] == '1')
    //     lock = true
    //   else
    //     lock = false
    //   r[o.split('-')[0]] = lock
    // }
    // return r
  }
  static getcreditBlockPrintAESetting() {
    // var setting: String = Config.configMap['creditBlockPrintAE']
    // if (1 == Config.configMap['useParentCreditSettingAE']) {
    //   setting = Config.configMap['creditBlockPrintAEP']
    // }
    // var a: Array = setting.split(',')
    // var r = {}
    // for each(var o: String in a)
    // {
    //   var lock: Boolean
    //   if (o.split('-')[1] == '1')
    //     lock = true
    //   else
    //     lock = false
    //   r[o.split('-')[0]] = lock
    // }
    // return r
  }
  // 如果开启总公司配置，取用总公司配置
  static getcreditModeAESetting() {
    // var setting: String = Config.configMap['creditModeAE']
    // if (1 == Config.configMap['useParentCreditSettingAE']) {
    //   setting = Config.configMap['creditModeAEP']
    // }
    // return setting
  }
  /**
   * 检查客户、目的港代理、指定代码、结算对象是否超出黑名单
   * @param checkCustomerId 是否委托单位
   */
  static async checkCreditBlack(job, checkCustomerId = true, oldJob) {
    if (!job) {
      return false
    }
    await cache.load(cacheName.CONFIG)
    // CreditBlackListMode 参数开启时，黑名单校验对象受限（历史逻辑）；此处仅保留委托单位校验
    if (Number(cache.config.get('CreditBlackListMode')) === 1) {
      let needCheck = false
      const map = {}
      const prev = oldJob || {}
      const isNewJob = !job.uuid
      const cargoSourceChanged = job.cargoSource !== prev.cargoSource

      // 委托单位：无论是否指定货，均需要校验黑名单（由 checkCustomerId 控制是否跳过）。
      if (checkCustomerId && job.customerId > 0) {
        if (isNewJob || cargoSourceChanged || job.customerId !== prev.customerId) {
          map[String(job.customerId)] = job.customerId
          needCheck = true
        }
      }

      if (needCheck) {
        const creditInfos = await checkCreditInfo(map).then(res => res.data)
        for (const creditInfo of creditInfos) {
          const flag = await this.checkCreditInfoWithAllocation(creditInfo, job)
          if (!flag) {
            return false
          }
        }
      }
      return true
    } else {
      const map = {}
      if (job.customerId > 0 && checkCustomerId) {
        map[String(job.customerId)] = job.customerId
      }
      if (job.destinationAgent > 0) {
        map[String(job.destinationAgent)] = job.destinationAgent
      }
      if (job.charges && job.charges.length > 0) {
        for (const c of job.charges) {
          if (job.customerId > 0 && c.accountId === job.customerId && !checkCustomerId) continue
          map[String(c.accountId)] = c.accountId
        }
      }
      const creditInfos = await checkCreditInfo(map).then(res => res.data)
      for (const creditInfo of creditInfos) {
        const flag = await this.checkCreditInfo(creditInfo)
        if (!flag) {
          return false
        }
      }
      return true
    }
  }
  /**
   * 错误提示
   */
  static async checkCreditInfo(creditInfo) {
    if (creditInfo.blacklist) {
      this.companyList = await getSpecificBasicData(basicCacheKeys.basic_data_Company)
      const comp = this.companyList.find(p => p.uuid === creditInfo.companyUuid)
      if (comp) {
        if (comp.chineseName) {
          throw new ErrorTip('[' + comp.chineseName + ']' + i18n.t('CargoMsg.Cargo_Blacklisted'))
        } else {
          throw new ErrorTip('[' + comp.englishName + ']' + i18n.t('CargoMsg.Cargo_Blacklisted'))
        }
      }
    }
    return true
  }

  /**
   * 错误提示 检查客户是否超出黑名单（包含分配额度校验）
   * @param creditInfo 客户信息
   * @param job 作业信息
   * @returns {Promise<boolean>} 是否校验通过
   */
  static async checkCreditInfoWithAllocation(creditInfo, job) {
    const allocation = creditInfo.partnerNumberAllocation
    const numberAllocationLimit = allocation && Number(allocation.numberAllocationLimit)
    const requiredAllocation = job.copyNum > 0 ? job.copyNum : 1
    if (!creditInfo.blacklist) {
      return true
    }
    if (!job.uuid && allocation && numberAllocationLimit > 0 && numberAllocationLimit >= requiredAllocation) {
      Message.warning(i18n.t('CargoMsg.Cargo_BlacklistedWithRemainingAllocation', [numberAllocationLimit - 1]))
      return true
    }
    this.companyList = await getSpecificBasicData(basicCacheKeys.basic_data_Company)
    const comp = this.companyList.find(p => p.uuid === creditInfo.companyUuid)
    if (comp) {
      if (comp.chineseName) {
        throw new ErrorTip('[' + comp.chineseName + ']' + i18n.t('CargoMsg.Cargo_Blacklisted'))
      } else {
        throw new ErrorTip('[' + comp.englishName + ']' + i18n.t('CargoMsg.Cargo_Blacklisted'))
      }
    }
    return true
  }
}
